$(function () {
  console.log("Ganpati Bappa Morya!!");
  let winWT = $(window).innerWidth();
  let lenis;

  function reconnectLenis() {
    lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: "vertical",
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1,
      infinite: false,
    });
    lenis.on("scroll", ScrollTrigger.update);
    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);
  }
  reconnectLenis();

  AOS.init({
    easing: "ease-out-in",
    duration: 1200,
    once: true,
    /* disable: function () {
      var maxWidth = 767;
      return window.innerWidth < maxWidth;
    } */
  });

  gsap.registerPlugin(ScrollTrigger);

  function setHeaderOnScroll() {
    winWT = $(window).innerWidth();
    if (winWT >= 1024) {
      if ($(this).scrollTop() > 120) {
        $("header").addClass("sticky");
      } else {
        $("header").removeClass("sticky");
      }
    }
  }
  setHeaderOnScroll();

  $(window).on("scroll", function () {
    setHeaderOnScroll();
  });

  $(window).on("resize", function () {
    setHeaderOnScroll();
    //parallaxBanner();
  });

  /*  $('.scroll-indicator').click(function() {
    $('html, body').animate({
      scrollTop: $('section').next().offset().top
    }, 1000);
  }); */

  function callCounters() {
    const counters = document.querySelectorAll(".counter");
    counters.forEach((counter) => {
      counter.innerText = "0";
      const updateCounter = () => {
        const target = +counter.getAttribute("data-target");
        const count = +counter.innerText.replace(/,/g, "");
        const increment = target / 200;
        if (count < target) {
          const nextValue = Math.ceil(count + increment);
          counter.innerText = Number.isInteger(nextValue)
            ? nextValue.toLocaleString()
            : nextValue.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              });
          setTimeout(updateCounter, 9);
        } else
          counter.innerText = Number.isInteger(target)
            ? target.toLocaleString()
            : target.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              });
      };
      updateCounter();
    });
  }

  function parallaxBanner() {
    gsap.utils.toArray(".parallax-banner").forEach(function (container) {
      let image = container.querySelector("img");

      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          scrub: true,
          pin: false,
        },
      });
      tl.from(image, {
        yPercent: -30,
        scale: 1.3,
        ease: "none",
      }).to(image, {
        yPercent: 30,
        scale: 1,
        ease: "none",
      });
    });
  }
  setTimeout(function () {
    parallaxBanner();
  }, 400);

  wow = new WOW({
    //mobile: false,
    offset: 150,
  });
  wow.init();

  /*  $('.modal').on('show.bs.modal', function () {
    lenis.destroy();
    $('body').css('overflow', 'hidden');
  });
  
  $('.modal').on('hidden.bs.modal', function () {
    lenis.start();
    $('body').css('overflow', '');
    reconnectLenis();
  });
 */

  /*************************************************************************************************************/
  /*************************************************************************************************************/

  var swiperMobilitySolutionsSlider = new Swiper(".mobility-slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    /*  autoplay: {
      delay: 3000,
     // disableOnInteraction: false
    }, */
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
      clickable: true,
    },
    speed: 400,
  });

  let valuesAccordionList = $(".our-values").find(".accordion-item");
  console.log(valuesAccordionList.length);
  valuesAccordionList.each(function () {
    $(this).on("click", function () {
      console.log("yes");
      if ($(this).hasClass("active-item")) {
        $(valuesAccordionList).removeClass("active-item");
      } else {
        $(valuesAccordionList).removeClass("active-item");
        $(this).addClass("active-item");
      }
    });
  });

  var swiperEnvCounterSlider = new Swiper(".env-counter", {
    spaceBetween: 20,
    slidesPerView: 1,
    /* autoplay: {
				delay: 6000,
				// disableOnInteraction: false
			}, */
    speed: 600,
    pagination: {
      el: ".env-counter .swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
    },
  });
  var swiperSocialCounterSlider = new Swiper(".social-counter", {
    spaceBetween: 0,
    slidesPerView: 1,
    /* autoplay: {
				delay: 6000,
				// disableOnInteraction: false
			}, */
    speed: 600,
    pagination: {
      el: ".social-counter .swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
    },
  });
  var swiperGovernanceCounterSlider = new Swiper(".governance-counter", {
    spaceBetween: 0,
    slidesPerView: 1,
    /* autoplay: {
				delay: 6000,
				// disableOnInteraction: false
			}, */
    speed: 600,
    pagination: {
      el: ".governance-counter .swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
    },
  });

  /* $(".esg-panel").each(function (index, panel) {
    var nextPanel = $(".esg-panel").eq(index + 1);
    
    if (nextPanel.length) {
      gsap.to(panel, {
        scrollTrigger: {
          trigger: panel,
          start: "top 70px",
          end: "bottom top",
          scrub: true,
          pin: true,
          pinSpacing: false,
        },
      });
    } else {
      gsap.to(panel, {
        scrollTrigger: {
          trigger: panel,
          start: "top top",
          end: "bottom bottom",
          scrub: true,
          pin: true,
          pinSpacing: true,
        },
      });
    }
  }); */

  // Create a container for pinning (add this wrapper in HTML if needed: <div class="esg-container"> all .esg-panel </div>)
  /* const panels = gsap.utils.toArray(".esg-panel");
const container = document.querySelector(".esg-container") || panels[0].parentElement; // Fallback to common parent

gsap.to(container, {
  scrollTrigger: {
    trigger: container,
    start: "top 70px",
    end: "+=100%",  // Matches total animation progress; adjust % or use function for dynamic height
    scrub: true,
    pin: true,
    pinSpacing: false,
    // Optional: markers: true for debugging
  }
});

// Optional: Add individual animations for each panel if not already present
panels.forEach((panel, index) => {
  gsap.fromTo(panel, 
    { y: 100, opacity: 0 },
    {
      y: 0,
      opacity: 1,
      duration: 1,
      scrollTrigger: {
        trigger: panel,
        start: "top 80%",
        end: "bottom 20%",
        scrub: true
      }
    }
  );
}); */

  const items = gsap.utils.toArray(".esg-panel");
  const lastItem = items[items.length - 2];

  items.forEach((item, index) => {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: item,
        start: "top top+=" + item.getAttribute("animation-item"),
        endTrigger: lastItem,
        end: "bottom top", // Changed: Last panel's BOTTOM hits viewport TOP
        pin: true,
        pinSpacing: false,
        scrub: true,
        markers: false,
      },
    });
    tl.to(item, {
      opacity: 1,
      /* scale: 0.85 + 0.02 * index,  */
      transformOrigin: "center center",
    });
  });

  function callCounters() {
    const counters = document.querySelectorAll(".counter");
    counters.forEach((counter) => {
      counter.innerText = "0";
      const updateCounter = () => {
        const target = +counter.getAttribute("data-target");
        const count = +counter.innerText.replace(/,/g, "");
        const increment = target / 200;
        if (count < target) {
          const nextValue = Math.ceil(count + increment);
          counter.innerText = Number.isInteger(nextValue)
            ? nextValue.toLocaleString()
            : nextValue.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              });
          setTimeout(updateCounter, 9);
        } else
          counter.innerText = Number.isInteger(target)
            ? target.toLocaleString()
            : target.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              });
      };
      updateCounter();
    });
  }

  function pageAnimations() {
    function animateSectionOnScroll(selector, timelineCallback) {
      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: selector,
          start: "top 50%",
          end: "bottom top",
          toggleActions: "play none none reverse",
          scrub: false,
          //markers: true,
        },
      });
      timelineCallback(tl, selector);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        animateSectionOnScroll(".esg-performance", function (tl, selector) { 
          callCounters();
        });
        animateSectionOnScroll(".our-company .comp-det", function (tl, selector) { 
          callCounters();
        });
      });
    }
  }

  $(window).on("load", function () {
    pageAnimations();
  });
});
